import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import HomeRoles from './components/HomeRoles';
import Footer from './components/Footer';
import AboutPage from './components/AboutPage';
import MembershipPage from './components/MembershipPage';
import StandardsPage from './components/StandardsPage';
import IndustryPage from './components/IndustryPage';
import ContactPage from './components/ContactPage';
import MembershipForm from './components/MembershipForm';
import BylawsPage from './components/BylawsPage';
import HomeBylawsBanner from './components/HomeBylawsBanner';
import HomeContactStrip from './components/HomeContactStrip';
import HomeContactSurvey from './components/HomeContactSurvey';
import ProfessionalStandardPage from './components/ProfessionalStandardPage';
import FloatContact from './components/FloatContact';
import AdminPanel from './components/AdminPanel';
import ApplicationInquiry from './components/ApplicationInquiry';

function App() {
  const getInitialPage = () => {
    if (typeof window !== 'undefined') {
      if (window.location.pathname === '/admin') return 'admin';
      if (window.location.pathname === '/basvuru') return 'membership-form';
    }
    return 'home';
  };
  const [currentPage, setCurrentPage] = useState(getInitialPage);
  const [showApplicationInquiry, setShowApplicationInquiry] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPage]);

  // URL senkronizasyonu
  useEffect(() => {
    if (currentPage === 'admin') {
      if (window.location.pathname !== '/admin') {
        window.history.replaceState({ page: 'admin' }, '', '/admin');
      }
    } else if (currentPage === 'membership-form') {
      if (window.location.pathname !== '/basvuru') {
        window.history.replaceState({ page: 'membership-form' }, '', '/basvuru');
      }
    } else if (window.location.pathname === '/admin' || window.location.pathname === '/basvuru') {
      window.history.replaceState({ page: 'home' }, '', '/');
    }
  }, [currentPage]);

  // Tarayıcı geri/ileri ile URL değişince sayfayı güncelle
  useEffect(() => {
    const onPopState = () => {
      const path = window.location.pathname;
      const page = path === '/admin' ? 'admin' : path === '/basvuru' ? 'membership-form' : 'home';
      setCurrentPage(page);
    };
    window.addEventListener('popstate', onPopState);
    return () => window.removeEventListener('popstate', onPopState);
  }, []);

  const PageLayout = ({ children }) => (
    <div className="App">
      <Navbar onNavigate={setCurrentPage} onOpenApplicationInquiry={() => setShowApplicationInquiry(true)} />
      {children}
      <Footer onNavigate={setCurrentPage} />
      <FloatContact />
      {showApplicationInquiry && <ApplicationInquiry onClose={() => setShowApplicationInquiry(false)} />}
    </div>
  );

  if (currentPage === 'about') {
    return <PageLayout><AboutPage /></PageLayout>;
  }
  if (currentPage === 'membership') {
    return <PageLayout><MembershipPage /></PageLayout>;
  }
  if (currentPage === 'standards') {
    return <PageLayout><StandardsPage /></PageLayout>;
  }
  if (currentPage === 'industry') {
    return <PageLayout><IndustryPage /></PageLayout>;
  }
  if (currentPage === 'contact') {
    return <PageLayout><ContactPage /></PageLayout>;
  }
  if (currentPage === 'membership-form') {
    return (
      <PageLayout>
        <MembershipForm onBack={() => setCurrentPage('home')} />
      </PageLayout>
    );
  }
  if (currentPage === 'bylaws') {
    return (
      <PageLayout>
        <BylawsPage onBack={() => setCurrentPage('home')} />
      </PageLayout>
    );
  }
  if (currentPage === 'professional-standard') {
    return (
      <PageLayout>
        <ProfessionalStandardPage onBack={() => setCurrentPage('standards')} />
      </PageLayout>
    );
  }
  if (currentPage === 'admin') {
    return (
      <PageLayout>
        <AdminPanel />
      </PageLayout>
    );
  }

  return (
    <div className="App">
      <Navbar onNavigate={setCurrentPage} onOpenApplicationInquiry={() => setShowApplicationInquiry(true)} />
      <Hero onNavigate={setCurrentPage} />
      <HomeBylawsBanner onNavigate={setCurrentPage} />
      <HomeRoles onNavigate={setCurrentPage} />
      <HomeContactSurvey />
      <HomeContactStrip onNavigate={setCurrentPage} />
      <Footer onNavigate={setCurrentPage} />
      <FloatContact />
      {showApplicationInquiry && <ApplicationInquiry onClose={() => setShowApplicationInquiry(false)} />}
    </div>
  );
}

export default App;
